import React from "react"
import { CardDeck, CardColumns, Card, Container, Col, Row } from 'react-bootstrap';
import { Link, graphql} from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

export const pageQuery = graphql`
  query {
    allMdx(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            titleImage {
                      childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid
            }
          }
            }
            title
            category
            visible
            view
          }
          fileAbsolutePath
        }
      }
    }
  }
`

const Blog = ({
    data: {
        allMdx: { edges },
    },
}) => {
    const classes = ['cloud-sky', 'green-sky', 'yellow-sky', 'pink-sky']
    let i = 0
    return (
  <Layout icon="blog">
      <Container fluid>
      <Row xs={1} sm={1} md={2} lg={3} >
      {
          edges
        .filter(edge => {
            return !!edge.node.frontmatter.date && (
                edge.node.frontmatter.category === "post"
                || edge.node.frontmatter.view == 'blog'
            )&& edge.node.frontmatter.visible
        }) // You can filter your posts based on some criteria
              .map((edge) => {
                  //TODO
                  const filename = (edge.node.fileAbsolutePath).toString().split("/").pop().split(".")[0]
                  const fm = edge.node.frontmatter
                  const title = fm.title.toString()
                  const titleLimit = 25
                  const image = (fm.titleImage && fm.titleImage.childImageSharp) ? fm.titleImage.childImageSharp.fluid : null
                  return (
                          <Col key={filename}>
                      <Card style={{margin:'1rem', border: '3px solid rgba(0,0,0,.125)', borderRadius: '0'}}>
                          {/* <Card.Header className="cloud-sky" style={{minHeight: "2rem"}}> */}
                          {/* </Card.Header> */}
                          {/* <Card.Img variant="top" src={fm.titleImage || 'https://via.placeholder.com/150' } /> */}
                          <Card.Body style={{padding: '0'}}>
                              <Card.Title style={{height:'4rem', overflow: 'hidden', padding: '1rem', marginBottom: '0'}}>
                                  <Link to={`../${filename}`} >
                                      {/* {title.length > titleLimit ? title.substr(0, titleLimit-3) + '...' : title} */}
                                      {title}
                                  </Link>
                              </Card.Title>
                              <div style={{width: '100%', height: '5rem', overflow: 'hidden'}}>
                                  {image ? (<Img fluid={image} />) : (
                                      <div className={
                                          classes[i++%4]
                                      } style={{width:'100%', height: '100%'}}> </div>
                              )}
                              </div>
                              <Card.Text style={{fontWeight: 200, fontSize: 'medium', height: '7rem', overflow: 'hidden', padding: '1rem'}}>
                                  {edge.node.excerpt.split(".")[0].substr(0, 90) + '...'}
                              </Card.Text>
                          </Card.Body>
                          <Card.Footer style={{paddingTop: '0', paddingBottom: '0', backgroundColor: '#fff', borderTop:'none'}}>
                              <small style={{color:'#ccc'}}>
                                  {fm.date}
                              </small>
                          </Card.Footer>
                      </Card>
                  </Col>

                  )
              })
      }
  </Row>
  </Container>
  </Layout>
)
}

export default Blog

